import { render } from "./bookmiSpecials.vue?vue&type=template&id=9c1f4558&scoped=true"
import script from "./bookmiSpecials.vue?vue&type=script&lang=js"
export * from "./bookmiSpecials.vue?vue&type=script&lang=js"

import "./bookmiSpecials.vue?vue&type=style&index=0&id=9c1f4558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c1f4558"]])

export default __exports__